import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Api } from './api';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { isNull, isUndefined } from 'util';

@Injectable()
export abstract class ApiService<T> {


  protected resource: string;

  constructor(protected api: Api) {
  }

  /**
   * Send get request for array of <T>
   */
  query(urlParams?: Object, params?: Object): Observable<T[]> {
    return this.api.get(this.createPath(urlParams), params)
      .catch((error) => Observable.throw(error));
  }

  /**
   * Send get request for single <T>
   * @param params for URI replacement for example: {id: 3} or number for :id param
   * @return {Observable<any>}
   */
  get(params: Object | number): Observable<T> {
    return this.api.get(this.createPath(params))
      .catch((error) => Observable.throw(error));
  }

  /**
   * Send POST request to create new <T> object
   * @param payload <T> object to create
   */
  create(payload: T): Observable<T> {
    return this.api.post(this.createPath(payload), payload)
      .catch((error) => Observable.throw(error));
  }

  /**
   * Sent PUT request to update <T> object
   * @param payload <T> object to update
   */
  update(payload: T): Observable<T> {
    return this.api.patch(this.createPath(payload), payload)
      .catch((error) => Observable.throw(error));
  }

  /**
   * Send DELETE request to remove <T> object
   * @param params for URI replacement for example: {id: 3} or number for :id param
   * @return {Observable<any>}
   */
  destroy(params: Object | number): Observable<boolean> {
    return this.api.delete(this.createPath(params))
      .catch((error) => Observable.throw(error));
  }

  protected createPath(params: any): string {
    if (typeof params !== 'object') {
      params = { id: params };
    }
    let path = this.resource;
    const uri_params = path.match(/(\/:[^\/]*)/g);
    if (isNull(uri_params)) {
      return path;
    }
    uri_params.reduce((prev, curr) => {
      const key = curr.replace('/:', '');
      const replacement = !isUndefined(params[ key ]) ? '/' + params[ key ] : '/';
      path = path.replace(curr, replacement);
      return path;
    }, path);
    return path.replace(/\/$/, '');
  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/core/apiService.ts